"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyOf = void 0;
const interface_js_1 = require("./interface.js");
const options_js_1 = require("./options.js");
/**
 * Define a new anyOf attribute
 * @param elements Attribute[]
 * @param options _(optional)_ AnyOf Options
 */
const anyOf = (...elements) => new interface_js_1.$AnyOfAttribute(options_js_1.ANY_OF_DEFAULT_OPTIONS, elements);
exports.anyOf = anyOf;
